/** When your routing table is too long, you can split it into small modules**/


export default [
  {
    path: '/branch',
    name: 'branches',
    component: () => import('@/views/branch/Index'),
  },
  {
    path: '/branch/roles',
    name: 'roles',
    component: () => import('@/views/branch/Roles'),
  }
  , {
    path: '/branch/people',
    name: 'people',
    component: () => import('@/views/branch/People'),
  },
  {
    path: '/branch/places',
    name: 'places',
    component: () => import('@/views/branch/Places'),
  },

  {
    path: '/branch/meals',
    name: 'meals',
    component: () => import('@/views/branch/Meals'),
  },
  {
    path: '/branch/foods',
    name: 'foods',
    component: () => import('@/views/branch/Foods'),
  },
  {
    path: '/branch/menus',
    name: 'menus',
    component: () => import('@/views/branch/Menus'),
  },
  {
    path: '/branch/payments',
    name: 'payments',
    component: () => import('@/views/branch/Payments'),
  },
  {
    path: '/branch/schools',
    name: 'schools',
    component: () => import('@/views/branch/Schools'),
  },
  {
    path: '/branch/orders',
    name: 'orders',
    component: () => import('@/views/branch/Orders'),
  },
  {
    path: '/branch/reserve',
    name: 'reserve',
    component: () => import('@/views/branch/Reserve'),
  },
  {
    path: '/branch/ordersReport',
    name: 'ordersReport',
    component: () => import('@/views/branch/OrdersReport'),
  },
  {
    path: '/branch/options',
    name: 'options',
    component: () => import('@/views/branch/Options'),
  },
  {
    path: '/branch/users',
    name: 'users',
    component: () => import('@/views/branch/Users'),
  },

  {
    path: '/branch/allusers',
    name: 'allusers',
    component: () => import('@/views/branch/AllUsers'),
  },

  {
    path: '/branch/paybacks',
    name: 'branchPaybacks',
    component: () => import('@/views/branch/Paybacks'),
  },


  {
    path: '/branch/allorders',
    name: 'allorders',
    component: () => import('@/views/branch/AllOrders'),
  },

  


]

